<template>
  <IconWrapper :dense="dense">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 9.75C8.5875 9.75 8.25 9.4125 8.25 9V6C8.25 5.5875 8.5875 5.25 9 5.25C9.4125 5.25 9.75 5.5875 9.75 6V9C9.75 9.4125 9.4125 9.75 9 9.75ZM9.75 12.75H8.25V11.25H9.75V12.75Z"
      />
    </svg>
  </IconWrapper>
</template>

<script>
import IconWrapper from './IconWrapper'

export default {
  components: {
    IconWrapper
  },

  props: {
    dense: Boolean
  }
}
</script>

<style lang="scss" scoped>
svg path {
  fill: var(--r-danger-1);
}
</style>
